/**
 * עוטף כל מסך פאנל שדורש סשן פעיל — בודק מול `/api/admin/me` ומפנה
 * ל-`/admin/login` אם אין. TASKS 3.1: "middleware על כל /api/admin/*" — זהו
 * ⛔ **הצד שלנו** בצד הלקוח, ⛔ לא תחליף לבדיקת השרת (שם האכיפה האמיתית).
 */
import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { adminMe } from './adminApi.js';

type SessionState =
  { kind: 'loading' } | { kind: 'authenticated'; username: string } | { kind: 'anonymous' };

export function RequireAuth({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<SessionState>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;

    adminMe()
      .then((result) => {
        if (cancelled) return;
        setSession(
          result ? { kind: 'authenticated', username: result.username } : { kind: 'anonymous' },
        );
      })
      .catch(() => {
        if (!cancelled) setSession({ kind: 'anonymous' });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (session.kind === 'loading') {
    return (
      <p className="text-muted p-8 text-center" role="status" aria-live="polite">
        בודק התחברות…
      </p>
    );
  }

  if (session.kind === 'anonymous') {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}
